<template>
	<v-tooltip v-if="tooltip" :bottom="tooltipPosition === 'bottom'" :right="tooltipPosition === 'right'" color="white" content-class="rmp-tooltip">
		<template v-slot:activator="{ attrs, on }">
			<inline-svg :src="processedSrc"
						:style="svgStyles"
						v-bind="attrs"
						@mouseenter="isHovered = true"
						@mouseleave="isHovered = false"
						v-on="on">
			</inline-svg>
		</template>
		<span class="grey--text text--darken-4">{{ tooltip }}</span>
	</v-tooltip>
	<div v-else :style="styleObject" class="d-flex" @click="$emit('click')">
		<inline-svg :src="processedSrc"
					:style="svgStyles"
					@mouseenter="isHovered = true"
					@mouseleave="isHovered = false">
		</inline-svg>
	</div>
</template>

<script setup lang="ts">
import InlineSvg from "vue-inline-svg";
import { computed, ref } from "vue";

interface RmpIconProps {
	src: string;
	color?: string;
	hoverColor?: string;
	height?: string | number;
	width?: string | number;
	size?: string | number;
	tooltip?: string;
	right?: boolean;
	tooltipPosition?: "bottom" | "right";
}

const props = withDefaults(defineProps<RmpIconProps>(), {
	width: "fit-content",
	tooltipPosition: "bottom",
	hoverColor: undefined
});

const isHovered = ref(false);

const styleObject = computed(() => {
	return {
		color: props.color
	};
});

const svgStyles = computed(() => {
	return {
		height: props.size || props.height,
		width: props.size || props.width,
		color: isHovered.value && props.hoverColor ? props.hoverColor : props.color,
		transition: "color 0.2s ease"
	};
});

const processedSrc = computed(() => {
	return `/img/icons/${props.src}.svg`;
});
</script>
